/**
 * UranIA PA — `/accedi`, bivio PA / imprese e cittadini.
 *
 * Fusione A.4.2 (Riordino della mappa delle rotte §4): assorbe il
 * contenuto di `/scegli-accesso` (Fase 2 redesign vetrina/accesso,
 * 2026-09-01 — `ScegliAccessoPage`, invariata nel merito) e la rotta
 * `/login` (split-screen generico con `SpidButton`/`AltIdentityButton`
 * reali, ma duplicava `/login/pa` con meno cura: "il padre non può essere
 * anche una terza variante dei figli"). Entrambe restano come redirect a
 * qui (`routes/scegli-accesso.tsx`, `routes/login.tsx`).
 *
 * Nota di sequenza: il documento originale mette la rinomina
 * `/scegli-accesso → /accedi` fra le "rinomine di sola coerenza"
 * rinviabili al Rilascio B. Farla adesso invece di aprire uno stato
 * intermedio (`/login → /scegli-accesso`, poi da correggere in B) evita
 * una contraddizione fra l'albero §3 — che mostra già `/accedi` come
 * nome reale — e la tabella di migrazione §4. Il rischio è quello che il
 * documento stesso descrive come minimo ("le fusioni sono a rischio zero
 * sui link circolati, le rinomine no" — ma `/scegli-accesso` è una rotta
 * nuova, 2026-09-01, non ancora citata in atti; resta comunque un
 * redirect).
 */

import { createRoute, Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import { Route as PubblicoRoute } from './_pubblico.tsx';

function AccediPage(): JSX.Element {
  return (
    <section className="urania-scegli-accesso py-5" data-testid="accedi-page">
      <div className="mx-auto text-center" style={{ maxWidth: 760 }}>
        <h1 className="h3 mb-5">Sei un funzionario della Pubblica Amministrazione?</h1>

        <div className="row g-4 justify-content-center">
          <div className="col-12 col-md-6">
            <Link
              to="/login/pa"
              className="urania-scegli-accesso__card d-block h-100 text-decoration-none"
              data-testid="accedi-pa"
            >
              <span className="d-block h5 mb-2">Accedi come Pubblica Amministrazione</span>
              <span className="d-block small text-muted">
                Funzionari, Autorità di Gestione, Organismi Intermedi, Soggetti Attuatori
              </span>
            </Link>
          </div>

          <div className="col-12 col-md-6">
            <Link
              to="/login/beneficiari"
              className="urania-scegli-accesso__card d-block h-100 text-decoration-none"
              data-testid="accedi-imprese"
            >
              <span className="d-block h5 mb-2">Accedi come Impresa, Cittadino o Innovatore</span>
              <span className="d-block small text-muted">
                Per orientarti in un bando o nella progettazione di una proposta
              </span>
            </Link>
          </div>
        </div>

        <Link to="/" className="d-inline-block mt-5 small">
          Torna alla home
        </Link>
      </div>
    </section>
  );
}

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/accedi',
  component: AccediPage,
});
